import { Alert, Card, Skeleton } from "antd";
import { useState } from "react";
import useRevenueChartV2 from "../../hooks/useRevenueChartV2";
import RevenueChart from "./RevenueChart";
import RevenuePeriodSelector from "./RevenuePeriodSelector";

export default function RevenueCardChart({
  branchId,
  start,
  end,
  filtros,
  enabled = true,
}) {
  const [selectedPeriod, setSelectedPeriod] = useState("week");

  const grafico = useRevenueChartV2({
    branchId,
    start,
    end,
    periodo: selectedPeriod,
    filtros,
    enabled,
  });

  return (
    <Card
      title="Análise Gráfica do Faturamento"
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "var(--ouran-card-header-bg)",
        },
      }}>
      <div style={{ marginBottom: 16 }}>
        <RevenuePeriodSelector
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
        />
      </div>

      <div style={{ minHeight: "400px" }}>
        {grafico.isLoading ? (
          <Skeleton active style={{ height: "100%" }} />
        ) : grafico.error ? (
          <Alert
            message="Erro ao carregar dados"
            description="Não foi possível carregar os dados de faturamento. Por favor, tente novamente mais tarde."
            type="error"
            showIcon
          />
        ) : (
          <RevenueChart
            labels={grafico.data?.labels}
            faturamento_data={grafico.data?.faturamento}
            conversionData={grafico.data?.conversao}
            conversionLabel="Conversão (%)"
            permanenceData={grafico.data?.exposicao}
            style={{ height: "100%" }}
          />
        )}
      </div>
    </Card>
  );
}
